import { ErrorHandler, Injectable } from "@angular/core";
import { LoggerService } from '../logger/logger.service';

import * as Sentry from '@sentry/angular';

// global error handler catch chuncks loading issues and log them. other errors should be treated in their origin file 
@Injectable({
    providedIn: "root"
})
export class GlobalErrorHandler implements ErrorHandler {
	private readonly loggerName = 'GlobalErrorHandler';
	private readonly chunkFailedMessage = /Loading chunk [\d]+ failed/;

	constructor(
		private logger: LoggerService
	) { }
	
	handleError(error: any): void {
    	if(error?.message && this.chunkFailedMessage.test(error.message)) {
			this.logger.info(this.loggerName, 'Chunk load failed, refreshing to new version');
			window.location.reload();
			return;
		}

		// Log to console
		console.error(error);

		Sentry.withScope(scope => {
			scope.setLevel('error');
			scope.setTag('error_type', 'unhandled_error');
			scope.setExtra('error_message', error?.message);
			scope.setExtra('stack_trace', error?.stack);
			Sentry.captureException(error);
		});
	}
}
